module.exports = __webpack_public_path__ + "img/Vectorright_disabled.35edfa79.svg";